/**
 * TanStack Query hook for the document_categories catalog (Story SCH-2.5).
 *
 * Reads via direct Supabase query (RLS enforces tenant + globals
 * visibility). Used by the DocumentsTab filter dropdown so custom
 * (tenant-added) categories appear alongside the seeded built-ins.
 */

import { useQuery } from '@tanstack/react-query';
import { useTenant } from '@/contexts/TenantContext';
import {
  documentCategoriesService,
  type DocumentCategory,
} from '@/services/documentCategoriesService';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useDocumentCategories() {
  const { currentTenant } = useTenant();
  const tenantId = currentTenant?.tenant_id;
  return useQuery<DocumentCategory[]>({
    queryKey: ['document-categories', tenantId],
    queryFn: () => documentCategoriesService.listDocumentCategories(),
    enabled: !!tenantId,
    staleTime: FIVE_MINUTES,
  });
}
